import React from 'react';
import { Ruler } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Card, pnlCls, money } from './LearningParts';

/** 📐 Aralık Botu'nun öğrenme/trader durumu (öğrenme sayfasında): seviye, not, denge, coin karnesi ve ipuçları. */
export default function RangeLearningCard({ rg }) {
    const navigate = useNavigate();
    if (!rg) return null;
    const t = rg.trader || {};
    const b = rg.balance || {};
    return (
        <Card title="📐 Aralık Botu — öğrenme ve trader durumu" testId="learn-range"
              right={<button type="button" onClick={() => navigate('/aralik-bot')} className="text-[10px] text-sky-300 hover:underline" data-testid="learn-range-open">son {rg.days} gün · {rg.sample} kapanış · toplam {rg.total} · bota git →</button>}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                <div className="rounded-md border border-slate-800 bg-slate-950/50 px-2.5 py-2 flex items-center gap-3" data-testid="learn-range-level">
                    <div className="h-10 w-10 rounded-lg bg-sky-500 grid place-items-center text-slate-950 font-black"><Ruler className="h-5 w-5" /></div>
                    <div>
                        <div className="text-sm font-bold text-slate-50">Seviye {rg.level?.level} · {rg.level?.name}</div>
                        <div className="text-[10px] text-slate-400">{rg.level?.total} kapanış{rg.level?.next_at ? ` · ${rg.level.next_name} için ${rg.level.remaining} daha` : ''}</div>
                    </div>
                </div>
                <div className="rounded-md border border-slate-800 bg-slate-950/50 px-2.5 py-2" data-testid="learn-range-trader">
                    <div className="text-sm font-bold text-slate-50">Trader notu: {t.name}</div>
                    <div className="text-[10px] text-slate-400">{t.desc}{t.grade != null ? ` · kâr faktörü ${t.profit_factor} · isabet %${t.win_rate}` : ''}</div>
                </div>
            </div>
            {rg.sample > 0 && (
                <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-[11px]">
                    <Stat label="Net" value={money(b.pnl_usd)} cls={pnlCls(b.pnl_usd)} hint={`brüt kâr +${Number(b.gross_profit).toFixed(1)}$ / brüt zarar ${Number(b.gross_loss).toFixed(1)}$`} testId="learn-range-net" />
                    <Stat label="Ort. kâr / ort. zarar" value={`${Number(b.avg_win).toFixed(1)}$ / ${Number(b.avg_loss).toFixed(1)}$`} cls="text-slate-200" testId="learn-range-rr" />
                    <Stat label="Kapanışlar" value={`${b.reasons?.tp ?? 0} kademe hedefi · ${b.reasons?.stop ?? 0} sigorta · ${b.reasons?.manual ?? 0} elle`} cls="text-slate-200" hint={rg.avg_hours != null ? `ort. ${rg.avg_hours} sa/işlem` : ''} testId="learn-range-reasons" />
                    <Stat label="Coinler" value={(rg.coins || []).slice(0, 3).map((c) => `${c.symbol.replace('USDT', '')} ${money(c.pnl_usd)}`).join(' · ') || '—'} cls="text-slate-200" testId="learn-range-coins" />
                </div>
            )}
            {rg.tips?.length > 0 && (
                <ul className="space-y-0.5" data-testid="learn-range-tips">
                    {rg.tips.map((x, i) => <li key={i} className="text-[11px] text-sky-100">• {x}</li>)}
                </ul>
            )}
            {rg.sample === 0 && <div className="text-[11px] text-slate-400" data-testid="learn-range-empty">Bu defterde son {rg.days} günde kapanan aralık botu işlemi yok. Bot kademe kapattıkça burada coin karnesi ve ipuçları birikir.</div>}
        </Card>
    );
}

function Stat({ label, value, hint, testId, cls = 'text-slate-100' }) {
    return (
        <div className="rounded-md border border-slate-800 bg-slate-950/50 px-2 py-1.5" data-testid={testId}>
            <div className="text-[10px] text-slate-500">{label}</div>
            <div className={`font-mono font-bold ${cls}`}>{value}</div>
            {hint && <div className="text-[10px] text-slate-500">{hint}</div>}
        </div>
    );
}
